// extracted by mini-css-extract-plugin
export default {"appTextArea":"a_appTextArea__Zb2Zp","growWrap":"a_growWrap__h1DVR"};